import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const NetworkList = Loadable({ loader: () => import('./networkList'), loading: Loading });

export default { 
  list: NetworkList,
};